import PreDeliveryInspectionFaqs from "../pre-delivery-insection-faqs/component";
import { PAGE_LAYOUT } from "./constants";

export const getComponent = (pageSection) => {
    if (pageSection.startsWith("PDI_FAQ")) {
        return PreDeliveryInspectionFaqs;
    } else return PAGE_LAYOUT[pageSection];
};
